<template>
  <v-row>
    <v-col>
      <Table
        :items="items"
        :headers="allHeaders"
        :openDialog="openDialog"
        @headersUpdated="updateHeaders"
        class="mx-2"
        @refreshItems="refreshItems"
        :showRefresh="true"
      />
      <v-dialog
        v-model="open"
        max-width="500px"
        persistent
        @keydown.esc="reset(false)"
      >
        <Form
          :itemsSelect="dataSelects"
          :items="dataInputs"
          @save="saveForm"
          @cancel="reset"
          :maxWidth="maxWidth[0]"
          :mode="mode"
          :show="true"
        />
      </v-dialog>
      <DeleteDialog
        :showDialog="openDelete"
        :title="titleDelete"
        :confirmDelete="deleteItem"
        :cancelDelete="cancelDelete"
      />
    </v-col>
    <v-dialog v-model="isLoading" class="dialog__loader" :overlay-opacity="0.3">
      <Loader :loading="isLoading" />
    </v-dialog>
    <Snackbar :alert="alert" :color="color" :textAlert="textAlert" />
  </v-row>
</template>
<script>
import Table from "@/components/Complement/TableWithSearch";
import Form from "@/components/Complement/Form";
import DeleteDialog from "@/components/Complement/DeleteDialog.vue";
import Snackbar from "@/components/Complement/Snackbar.vue";
import Loader from "@/components/Complement/Loader.vue";
import modelsLiquidation from "@/store/modelosDeLiquidacion/modelsLiquidation";
import settlementRule from "@/models/modelosDeLiquidacion/Relations/settlementRule";
import date from "@/store/common/date";
import rulesLiquidations from "@/store/modelosDeLiquidacion/rulesLiquidation";
import configTable from "@/store/configuracionDeTablas/configTable.js";

export default {
  components: {
    Table,
    Form,
    DeleteDialog,
    Snackbar,
    Loader,
  },
  data() {
    return {
      title: this.$tc("modelsLiquidations.rulesLiquidation"),
      titleTable: "ModelosDeLiquidacion_ReglasDeLiquidacion",
      titleDelete: this.$tc("modelsLiquidations.toRuleLiquidationLiquidation"),
      isLoading: true,
      maxWidth: ["500px", "500px", "400px"],
      color: "#82A1D0",
      alert: false,
      textAlert: "",
      oldItems: null,
      headers: [
        {
          text: "Nombre",
          value: "name",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Orden",
          value: "order",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Acciones",
          value: "actions",
          class: "primary secondary--text",
          visible: true,
          sortable: false,
          width: "100px",
        },
      ],
      dataInputs: [
        {
          name: "order",
          label: "Orden",
          data: "",
          type: "Number",
          rules: [
            (v) => !!v || this.$tc("validation.required"),
            (v) => v >= 1 || this.$tc("validation.greaterThanZero"),
            (v) =>
              v < 10000000 || `${this.$t("validation.maxDigits", { max: 7 })}`,
          ],
        },
      ],
    };
  },
  computed: {
    allHeaders() {
      return configTable.state.colums;
    },
    items() {
      if (
        !modelsLiquidation.state.edit.reglasLiq ||
        modelsLiquidation.state.edit.reglasLiq.length === 0
      ) {
        return [];
      }

      return modelsLiquidation.state.edit.reglasLiq.map((item) => {
        return settlementRule.fromJson(item);
      });
    },
    rulesLiqudation() {
      return rulesLiquidations.state.rulesLiquidations;
    },

    rulesLiqudationSelected() {
      const editRulesLiqudation = this.editRulesLiqudation;
      if (editRulesLiqudation) {
        return rulesLiquidations.state.rulesLiquidations.filter(
          (rule) =>
            !editRulesLiqudation.some(
              (selected) => selected.reglaLiqId === rule.id
            )
        );
      } else {
        return rulesLiquidations.state.rulesLiquidations;
      }
    },

    editRulesLiqudation() {
      return modelsLiquidation.state.edit.reglasLiq;
    },
    dataSelects() {
      return [
        {
          name: "reglaLiqId",
          label: "Regla de liquidación",
          data: "",
          items: [],
          itemsValue: "id",
          itemsText: "name",
          rules: [
            (v) =>
              (v !== null && v !== undefined && v !== "") ||
              this.$tc("editRegistrations.requerid"),
          ],
          icon: "",
          readonly: false,
        },
      ];
    },
    mode: {
      get() {
        return modelsLiquidation.state.modeFormRelation;
      },
      set(newValue) {
        return newValue;
      },
    },
    open: {
      get() {
        return modelsLiquidation.state.openFormRelation;
      },
      set(newvalue) {
        return newvalue;
      },
    },
    openDelete: {
      get() {
        return modelsLiquidation.state.openDelete;
      },
      set(newvalue) {
        return newvalue;
      },
    },
  },
  async mounted() {
    configTable.commit("setColums", []);
    let nameTable = this.titleTable;
    configTable
      .dispatch("getColumsTableName", nameTable)
      .then(() => {
        if (
          configTable.state.colums.length === 0 ||
          configTable.state.colums.length !== this.headers.length
        ) {
          this.saveConfigColumns();
        }
      })
      .catch((error) => {
        console.error("Error occurred:", error);
      });

    await rulesLiquidations.dispatch("getRulesLiquidations");
    this.isLoading = false;
  },
  methods: {
    async refreshItems() {
      if (modelsLiquidation.state.edit.id) {
        await modelsLiquidation.dispatch(
          "getLiquidationModelId",
          modelsLiquidation.state.edit.id
        );
      }
    },
    updateHeaders(headers) {
      const updatedColums = headers;
      configTable.commit("setColums", updatedColums);
      this.saveConfigColumns();
    },
    saveConfigColumns() {
      let columnsToSave = configTable.state.colums;
      if (
        columnsToSave === undefined ||
        this.allHeaders.length !== this.headers.length ||
        columnsToSave.length === 0
      ) {
        columnsToSave = this.headers;
      }

      const configData = {
        operId: Number(localStorage.getItem("operId")),
        nameTable: this.titleTable,
        json: JSON.stringify(columnsToSave),
      };
      configTable.commit("setNew", configData);
      configTable.dispatch("new").then(() => {
        configTable.commit("setNew", []);
      });
    },
    async loadData() {
      try {
        await Promise.all([
          concepts.dispatch("getConcepts"),
          concepts.dispatch("getLiquidationModels"),
          clocks.dispatch("getClocks"),
          costCenters.dispatch("getCostCenters"),
          modelsLiquidation.dispatch("getLiquidationModels"),
        ]);

        this.isLoading = false;
      } catch (error) {
        console.error(error);
      }
    },
    showAlert(text, color) {
      this.alert = true;
      this.textAlert = text;
      this.color = color;

      setTimeout(() => {
        this.alert = false;
      }, 3000);
    },
    addRuleLiquidation(form) {
      let payload = form;
      payload.liqModeloId = modelsLiquidation.state.edit.id;
      modelsLiquidation.commit("setNew", payload);
      modelsLiquidation
        .dispatch("addRuleLiquidation")
        .then(() => {
          this.showAlert(
            this.$tc(
              "modelsLiquidations.addRuleLiquidationToLiquidationSuccess"
            ),
            "#82A1D0"
          );
        })
        .catch((error) => {
          if (error.response && error.response.status === 406) {
            this.showAlert(
              this.$tc("modelsLiquidations.errorRuleLiquidation406"),
              "#ff8d58"
            );
          } else {
            this.showAlert(
              this.$tc("modelsLiquidations.errorRuleLiquidation"),
              "#ff8d58"
            );
          }
        });
      this.reset(false);
    },

    editRuleLiquidation(form) {
      let payload = this.detectChanges(form);
      if (Object.keys(payload).length > 0) {
        payload.liqModeloId = modelsLiquidation.state.edit.id;
        payload.orderOld = this.oldItems.order;
        payload.id = this.oldItems.id;
        modelsLiquidation.commit("setEditRelation", payload);
        modelsLiquidation
          .dispatch("editRuleLiquidation")
          .then(() => {
            this.showAlert(
              this.$tc(
                "modelsLiquidations.editRuleLiquidationToLiquidationSuccess"
              ),
              "#82A1D0"
            );
          })
          .catch((error) => {
            if (error.response && error.response.status === 406) {
              this.showAlert(
                this.$tc("modelsLiquidations.errorRuleLiquidation406"),
                "#ff8d58"
              );
            } else {
              this.showAlert(
                this.$tc("modelsLiquidations.errorRuleLiquidation"),
                "#ff8d58"
              );
            }
          });
      } else {
        this.showAlert(this.$tc("validation.noEditsMessage"), "#F7DC6F");
      }

      this.reset(false);
    },
    detectChanges(newItems) {
      const changes = {};
      const oldItem = this.oldItems;

      if (oldItem) {
        if (oldItem.order !== Number(newItems.order)) {
          changes.order = newItems.order;
        }
      }

      return changes;
    },

    async openDialog(type, item) {
      this.typeForm = type;
      switch (this.typeForm) {
        case "add":
          this.dataSelects[0].items = this.rulesLiqudationSelected;
          this.dataSelects[0].readonly = false;
          modelsLiquidation.commit(
            "setModeFormRelation",
            this.$tc("modelsLiquidations.addRuleLiquidationToLiquidation")
          );
          modelsLiquidation.commit("setOpenFormRelation", true);
          break;

        case "edit":
          this.dataSelects[0].items = this.rulesLiqudation;
          this.dataSelects[0].readonly = true;
          this.itemId = item.id;
          this.oldItems = item;
          await this.setEdit(item);
          modelsLiquidation.commit(
            "setModeFormRelation",
            this.$tc("modelsLiquidations.editRuleLiquidationToLiquidation")
          );
          modelsLiquidation.commit("setOpenFormRelation", true);
          break;
        case "delete":
          modelsLiquidation.commit("setOpenDelete", true);
          this.itemToDelete = {
            ...item,
            liqModeloId: modelsLiquidation.state.edit.id,
          };
          break;

        default:
          break;
      }
    },

    setEdit(item) {
      this.dataSelects[0].data = item.id;
      this.dataInputs[0].data = item.order;
    },

    resetDate() {
      const day = new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10);
      date.commit("setDateFrom", day);
      date.commit("setDateTo", null);
    },

    reset(value) {
      this.resetDate();
      modelsLiquidation.commit("setOpenFormRelation", value);
      this.dataInputs.forEach((item) => {
        item.data = "";
      });
      this.dataSelects.forEach((item) => {
        item.data = "";
      });
    },

    saveForm(items) {
      switch (this.typeForm) {
        case "add":
          this.addRuleLiquidation(items);
          break;
        case "edit":
          this.editRuleLiquidation(items);
          break;
        default:
          break;
      }
    },

    deleteItem() {
      modelsLiquidation.commit("setItemDelete", this.itemToDelete);
      modelsLiquidation
        .dispatch("deleteRuleLiquidation")
        .then(() => {
          this.openDelete = false;
          modelsLiquidation.commit("setOpenDelete", false);
          this.showAlert(
            this.$tc(
              "modelsLiquidations.deleteRuleLiquidationToLiquidationSuccess"
            ),
            "#82A1D0"
          );
        })
        .catch((e) => {
          this.showAlert(
            this.$tc("modelsLiquidations.errorRuleLiquidation"),
            "#ff8d58"
          );
        });
    },

    cancelDelete() {
      this.openDelete = false;
      modelsLiquidation.commit("setOpenDelete", false);
    },
  },
};
</script>
